import { render, staticRenderFns } from "./HexCompany.vue?vue&type=template&id=51f2f1f0&scoped=true"
import script from "./HexCompany.vue?vue&type=script&lang=ts"
export * from "./HexCompany.vue?vue&type=script&lang=ts"
import style0 from "./HexCompany.vue?vue&type=style&index=0&id=51f2f1f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f2f1f0",
  null
  
)

export default component.exports